// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3niWt","body-wrapper":"body-wrapper__3g6Yw","body":"body__1rxCR","submission-evaluation-result-wrapper":"submission-evaluation-result-wrapper__iG7fx"};